import getStore from '../store/store';
import { mutatorAction } from 'satcheljs';

export const setShouldRenderCommandCenterPlaceholderMutator: (
    shouldRenderCommandCenterPlaceholder: boolean
) => void = mutatorAction(
    'setShouldRenderCommandCenterPlaceholder',
    (shouldRenderCommandCenterPlaceholder: boolean): void => {
        getStore().shouldRenderCommandCenterPlaceholder = shouldRenderCommandCenterPlaceholder;
    }
);
